import React from 'react';
import { Help } from '@atlaskit/atlassian-navigation';
import DocumentsIcon from '@atlaskit/icon/glyph/document-filled';
import RoomMenuIcon from '@atlaskit/icon/glyph/room-menu';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { DAC_LANDING_PAGE, SLACK_HELP_CHANNEL_LINK } from '@/constants';

const NavHelp: React.FC = () => (
  <DropdownMenu
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    trigger={({ triggerRef, ...props }) => <Help {...props} ref={triggerRef} tooltip="Help" />}
    placement="bottom-end"
  >
    <DropdownItemGroup>
      <DropdownItem
        elemBefore={<DocumentsIcon size="small" label="Docs" />}
        href={DAC_LANDING_PAGE}
        target="_blank"
      >
        View documentation on DAC
      </DropdownItem>
      <DropdownItem
        elemBefore={<RoomMenuIcon size="small" label="Slack" />}
        href={SLACK_HELP_CHANNEL_LINK}
        target="_blank"
      >
        Get help in #help-tome
      </DropdownItem>
    </DropdownItemGroup>
  </DropdownMenu>
);

export default NavHelp;
